export const TABS = {
  0: '#dashboard',
  1: '#analysis',
  2: '#config',
};
